import React, { useContext, useEffect, useState } from 'react';
import { FaGoogle, FaFacebookF } from "react-icons/fa";
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { ImSpinner2 } from "react-icons/im";
import { dataContext } from '../UserContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDmZo1aA9xt4ZVsmkqVrL6nfakfXUzOOrg",
  authDomain: "food-delivery-app-dca85.firebaseapp.com",
  projectId: "food-delivery-app-dca85",
  appId: "1:340126206490:web:34ab3f3b90e7e79c515fa3"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

function LoginPanel({ setShowLogin }) {
  const { setCurrentUser } = useContext(dataContext);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      setCurrentUser(user);
      setShowLogin(false);
      toast.success(`Welcome ${user.displayName || "User"}!`);
      console.log("Google User:", user);

    } catch (error) {
      console.error(error);
      toast.error('Google Sign-In failed!');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (isRegistering) {
      // Register new user
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(userCredential.user, { displayName: username });
        setCurrentUser(userCredential.user);
        setShowLogin(false);
        toast.success('Registered Successfully!');
      } catch (error) {
        console.error(error);
        toast.error(error.message || 'Registration failed!');
      }
    } else {
      // Login existing user
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        setCurrentUser(userCredential.user);
        setShowLogin(false);
        toast.success('Logged in Successfully!');
      } catch (error) {
        console.error(error);
        toast.error(error.message || 'Login failed!');
      }
    }

    setIsLoading(false);
  };

  return (
    <div className={`fixed top-0 right-0 h-full bg-white shadow-lg z-50 px-6 py-8 transition-transform duration-500 ${isVisible ? 'translate-x-0' : 'translate-x-full'}`} style={{ width: '320px', maxWidth: '400px' }}>
      <div className='flex justify-between items-center mb-6'>
        <h2 className='text-[20px] font-semibold text-orange-500'>
          {isRegistering ? 'Register' : 'Login / Register'}
        </h2>
        <span
          className='text-[20px] cursor-pointer font-bold text-orange-500'
          onClick={() => setShowLogin(false)}
        >
          ×
        </span>
      </div>

      <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
        <input 
          type="email" 
          placeholder="Email" 
          className='border p-2 rounded-md' 
          value={email} 
          onChange={(e) => setEmail(e.target.value)}
          required 
          disabled={isLoading} 
        />
        <input 
          type="password" 
          placeholder="Password" 
          className='border p-2 rounded-md' 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required 
          disabled={isLoading} 
        />
        {isRegistering && (
          <input 
            type="text" 
            placeholder="Username" 
            className='border p-2 rounded-md' 
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required 
            disabled={isLoading} 
          />
        )}
        <button type="submit" className='bg-orange-500 text-white p-2 rounded-md flex justify-center items-center gap-2' disabled={isLoading}>
          {isLoading ? <ImSpinner2 className='animate-spin' /> : (isRegistering ? 'Register' : 'Login')}
        </button>

        <div className='h-[50px] flex justify-evenly items-center'>
          <div
            className='md:w-[40px] md:h-[40px] w-[40px] h-[40px] bg-white flex justify-center items-center rounded-md shadow-md relative cursor-pointer'
            onClick={handleGoogleLogin}
          >
            {isLoading ? <ImSpinner2 className='w-[23px] h-[23px] animate-spin text-orange-400' /> : <FaGoogle className='w-[23px] h-[23px] text-orange-400' />}
          </div>

          <p className='text-[20px] font-bold text-orange-500'>or</p>

          <div className='md:w-[40px] md:h-[40px] w-[40px] h-[40px] bg-white flex justify-center items-center rounded-md shadow-md relative cursor-pointer'>
            <FaFacebookF className='w-[23px] h-[23px] text-orange-400' />
          </div>
        </div>
      </form>

      <p className='mt-4 text-sm text-center'>
        {isRegistering ? 'Already have an account?' : "Don't have an account yet?"}{' '}
        <span
          className='text-orange-500 cursor-pointer font-semibold'
          onClick={() => setIsRegistering(!isRegistering)}
        >
          {isRegistering ? 'Login' : 'Register'}
        </span>
      </p>
    </div>
  );
}

export default LoginPanel;
